import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    paddingBottom: 100,
    // backgroundColor: Colors.white,
    height: '100vh',
    boxSizing: 'border-box',
    overflow: 'auto',

    '& .floating-action': {
      backgroundColor: Colors.white,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 24,
      paddingTop: 4,
    },
  },
};

export default styles;
